"use client";

import { Info as InformationCircleIcon } from "lucide-react";
import {
  Tooltip as ShadcnTooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export interface TooltipProps {
  readonly content: React.ReactNode;
  readonly children?: React.ReactNode;
  readonly side?: "top" | "bottom" | "left" | "right";
  readonly align?: "center" | "start" | "end";
  readonly className?: string;
  readonly disabled?: boolean;
  /** Fixed width of the tooltip (px). Enables text wrapping. */
  readonly width?: number;
}

export function Tooltip({
  content,
  children,
  side = "top",
  align = "center",
  className = "",
  disabled = false,
  width,
}: TooltipProps) {
  if (disabled) {
    return <span className={`inline-flex ${className}`}>{children}</span>;
  }

  return (
    <ShadcnTooltip>
      <TooltipTrigger
        className={`inline-flex ${className}`}
        render={children ? <span /> : undefined}
      >
        {children || (
          <InformationCircleIcon className="h-4 w-4 text-gray-400 hover:text-gray-600 transition-colors cursor-help" />
        )}
      </TooltipTrigger>
      <TooltipContent
        side={side}
        align={align}
        style={width ? { width, maxWidth: "90vw" } : undefined}
      >
        {content}
      </TooltipContent>
    </ShadcnTooltip>
  );
}

interface FieldTooltipProps {
  readonly content: string;
  readonly className?: string;
}

export function FieldTooltip({ content, className = "" }: FieldTooltipProps) {
  return (
    <Tooltip content={content} side="top" width={240} className={className}>
      <InformationCircleIcon className="h-4 w-4 text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0 inline-block cursor-help" />
    </Tooltip>
  );
}
